import { type Enum } from '../../utils/enums'

export const IntegrationCodatConfigStatuses = {
  PENDING_AUTH: 'PendingAuth',
  LINKED: 'Linked',
  DEAUTHORIZED: 'Deauthorized',
  UNLINKED: 'Unlinked',
} as const

export type IntegrationCodatConfigStatus = Enum<
  typeof IntegrationCodatConfigStatuses
>
